export class Ingrediente {
  id: number;
  descricao: string;
  quantidade: number;
  nomeArquivo: string;
}
